// Export payload for the polarity-scale block, ported from the pptx / summary exporters. They
// describe the chart by what it plots rather than by the block's own mode token, so the mapping
// lives here beside the token grammar instead of being repeated per exporter.

import { MODE_TYPES } from '@aytm/app/stats/page/question-views/psc/lib/constants'

const MODE_TYPE_BY_MODE = {
  [MODE_TYPES.pba]: 'intensity_pairs',
  [MODE_TYPES.pbm]: 'intensity_pairs',
  [MODE_TYPES.pda]: 'intensity_deltas',
  [MODE_TYPES.pdm]: 'intensity_deltas'
}

const DELTA_TYPE_BY_MODE = {
  [MODE_TYPES.pda]: 'mean',
  [MODE_TYPES.pba]: 'mean',
  [MODE_TYPES.pdm]: 'median',
  [MODE_TYPES.pbm]: 'median'
}

// The chart size travels with the payload so the pptx exporter rasterizes the serialized svg at
// the size it was rendered at, rather than recomputing the geometry on its own.
export const calcExportData = ({ mode, neutral } = {}, chartSize = null) => ({
  modeType: MODE_TYPE_BY_MODE[mode] || 'popularity',
  deltaType: DELTA_TYPE_BY_MODE[mode] || null,
  neutral,
  chartWidth: chartSize?.width || null,
  chartHeight: chartSize?.height || null
})
